import styles from './index.less';
import robotUrl from '@/assets/home/robot.png';
import phoneUrl  from '@/assets/home/phone.png';
import { FC } from 'react';
import { history } from '@umijs/max';

interface IMajordomoProps {
  open: (value: boolean) => void;
  bindInformation: {
    car?: string,
    room?: string,
    park?: string,
  } | undefined
}

const Majordomo: FC<IMajordomoProps> = (props) => {
  const { open, bindInformation } = props;

  const checkBindRoom = () => {
    return (
      bindInformation?.car === '0' &&
      bindInformation?.room === '0' &&
      bindInformation?.park === '0'
    );
  };
  const toJump = (type: number) => {
    if (checkBindRoom()) {
      open(true)
      return
    }
    // open(true);
    if (type === 1) {
      history.push('/bult')
      return
    }

    if (type === 2) {
      history.push('/phone')
      return
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.contentItem} onClick={() => toJump(1)}>
        <div className={styles.content}>
          <img src={robotUrl} alt="robot" />
          <div>
            <p>【专属管家】</p>
            <span>全心全意为您服务</span>
          </div>
        </div>
        {/* <div onClick={openMask} className={styles.btn}>
          点击联系 <RightOutlined />
        </div> */}
      </div>

      <div className={styles.contentItem} onClick={() => toJump(2)}>
        <div className={styles.content}>
          <img src={phoneUrl} alt="robot" />
          <div>
            <p>【常用电话】</p>
            <span>查看</span>
          </div>
        </div>
        {/* <div onClick={openMask} className={styles.btn}>
          点击联系 <RightOutlined />
        </div> */}
      </div>
      
    </div>
  );
};

export default Majordomo;
